import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'timesync-modal-image-picker',
  templateUrl: './modal-image-picker.component.html',
  styleUrls: ['./modal-image-picker.component.scss']
})
export class ModalImagePickerComponent {
  
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageBlob?: Blob;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
  ) {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      (event).objectUrl!
    );
    this.imageBlob = event.blob!
    // event.blob can be used to upload the cropped image
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  close() {
    this.ref.close();
  }

  save(){
    this.ref.close({profile: this.imageBlob})
  }
}
